import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=16a27105&scoped=true"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"
import style0 from "./AccountDetails.vue?vue&type=style&index=0&id=16a27105&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a27105",
  null
  
)

export default component.exports